import { coreNl } from "./core/nl.js";

/** @type {import("../catalogTypes.js").MessageCatalog} */
export const nl = {
  common: {
    cancel: "Annuleren",
    done: "Klaar",
    save: "Opslaan",
    delete: "Verwijderen",
    rename: "Hernoem",
    remove: "Verwijder",
    share: "Deel",
    unknownError: "Onbekende fout",
    unknownDate: "Onbekende datum",
    actionFailed: "Actie mislukt",
    nameRequired: "Naam verplicht",
    nameRequiredBody: "Geef het project een naam.",
  },
  units: {
    kerf: "Kerf",
    margin: "Randmarge",
    marginValue: "Randmarge: {{value}}",
    standardSheet: "Standaardplaat",
    thickness: "{{value}} dikte",
    finalSize: "Eindmaat {{size}}",
    edges: "Kanten: {{edges}}",
    noEdges: "geen",
  },
  mobile: {
    common: {
      loadingA11y: "Laden",
    },
    nav: {
      projects: "Projecten",
      import: "Importeren",
      project: "Project",
    },
    shell: {
      eyebrow: "Werkplaatsmodus",
      brandName: "Plaatplan",
      subtitle: "Werkplaats zaagsimulator",
      splashLine1: "Importeer van plaatplan.nl",
      splashLine2: "Plaatschema & zaaglijst",
      splashLine3: "Werkplaatsmodus, stap voor stap",
    },
    projects: {
      webPromo: {
        eyebrow: "Gratis web-planner",
        title: "Plan op plaatplan.nl",
        body:
          "Voer thuis onderdelen in, maak zaagindelingen en exporteer je zaaglijst, gratis en zonder account. Importeer het project hier voor werkplaatsmodus naast de zaag.",
        bodyCompact:
          "Plan gratis op het web en importeer je project hier voor de werkplaatsmodus.",
        showMore: "Zo werkt het",
        showLess: "Minder tonen",
        stepPlan: "Onderdelen en platen plannen",
        stepExport: "Project exporteren als JSON",
        stepImport: "JSON importeren in deze app",
        openPlanner: "Open web-planner",
        openPlannerA11y: "Open plaatplan.nl in de browser",
        toggleExpandA11y: "Meer uitleg over de web-planner tonen",
        toggleCollapseA11y: "Uitleg over de web-planner verbergen",
      },
      getStartedSection: "Project binnenhalen",
      newSection: "Nieuw project",
      lead:
        "Importeer een projectbestand (.json) van de web-planner, of probeer het voorbeeldplan.",
      newDemo: "Nieuw voorbeeldplan",
      projectLimit: "Limiet: 1 project",
      importJson: "Importeer JSON",
      freeTierTitle: "Gratis versie",
      freeTierBody:
        "1 project, volledige zaaglijst en plaatoverzicht. Simulator: plaat 1 volledig. Import vervangt je huidige project als de limiet bereikt is.",
      savedProjects: "Opgeslagen projecten",
      savedProjectsCount: "Opgeslagen projecten ({{count}})",
      emptyTitle: "Nog geen projecten",
      emptyBody:
        "Importeer een .json van plaatplan.nl, of maak het voorbeeldplan om de werkplaatsmodus te proberen.",
      updatedAt: "Bijgewerkt {{date}} {{time}}",
      deleteTitle: "Project verwijderen",
      deleteBody: 'Weet je zeker dat je "{{name}}" wilt verwijderen?',
      renameTitle: "Project hernoemen",
      importSuccessTitle: "Import gelukt",
      importSuccessBody: "Het project staat nu in je projectlijst.",
      importFailedTitle: "Import mislukt",
      renameA11y: "{{name}} hernoemen",
      deleteA11y: "{{name}} verwijderen",
      openA11y: "Project {{name}} openen{{activeSuffix}}",
      activeSuffix: ", actief project",
      listStats: "{{parts}} onderdelen · {{sheets}} platen",
      listStatsWithCutProgress: "{{parts}} onderdelen · {{sheets}} platen · {{done}}/{{total}} gezaagd",
      emptyStepImport: "Importeer een .json van de web-planner",
      emptyStepDemo: "Of maak het voorbeeldplan met de knop hierboven",
    },
    devTools: {
      sectionTitle: "Ontwikkelaar",
      showOnboarding: "Toon introductiewizard",
      showOnboardingHint: "Wist de eerste-start vlag en opent de introductie.",
      resetFreemium: "Reset naar free tier",
      resetFreemiumHint: "Vergrendelt workshopmodus en houdt één project over voor paywall-testen.",
      resetFreemiumDoneTitle: "Free tier hersteld",
      resetFreemiumDoneBody: "Workshop-unlock gewist. Extra projecten zijn verwijderd.",
      previewUnlock: "Preview-unlock (dev)",
      previewUnlockHint: "Omzeilt de store voor lokaal testen. Niet in productie-paywalls.",
    },
    detail: {
      notFound: "Project niet gevonden.",
      backToProjects: "Terug naar projecten",
      backA11y: "Terug naar projecten",
      shareA11y: "Deel project als JSON",
      exportFailedTitle: "Export mislukt",
      partsAndSheets: "{{parts}} onderdelen · {{sheets}} platen",
      invalidParts: "{{count}} onderdeel(en) passen niet op de gekozen platen.",
      partsCount: "{{count}} onderdelen",
      sheetsCount: "{{count}} platen",
      restCount: "{{count}} rest",
      sheetsBlock: "Platen",
      sheetsBlockSummary: "{{count}} platen",
      sheetsBlockSummaryActive: "{{count}} platen · Plaat {{number}} geselecteerd",
      sheetsToggleA11y: "Platen, {{summary}}{{expandedSuffix}}",
      sheetsExpandedSuffix: ", uitgeklapt",
      sheetsCollapsedSuffix: ", ingeklapt",
      cutListBlock: "Zaaglijst",
      resetAllParts: "Alles resetten",
      resetAllPartsA11y: "Alle voortgang op de zaaglijst resetten",
      resetAllPartsTitle: "Zaagvoortgang resetten?",
      resetAllPartsBody: "Alle onderdelen worden weer als niet gezaagd getoond. Workshop-voortgang voor dit project wordt gewist.",
      resetAllPartsConfirm: "Alles resetten",
      resetPartHint: "Reset de zaagvoortgang voor dit onderdeel",
      markPartDoneHint: "Markeer dit onderdeel als gezaagd",
      markPartDoneA11y: "Markeer {{name}} als gezaagd",
      resetPartA11y: "Voortgang resetten voor {{name}}",
      resetPartTitle: "Dit onderdeel resetten?",
      resetPartBody: "“{{name}}” wordt weer als niet gezaagd getoond totdat je die zaags stappen opnieuw doorloopt in workshopmodus.",
      resetPartConfirm: "Resetten",
      partRowA11y: "{{quantity}} keer {{size}}, {{name}}{{doneSuffix}}",
      partDoneSuffix: ", gezaagd",
      cutListOrderBy: "Sorteer op",
      cutListOrderSubproject: "Subproject",
      cutListOrderSheet: "Plaat",
      cutListOrderOptionA11y: "{{label}}{{selectedSuffix}}",
      cutListGroupA11y: "{{label}}, {{parts}} onderdelen, {{pieces}} stuks{{progressSuffix}}",
      cutListGroupCounts: "{{parts}} onderdelen, {{pieces}} stuks",
      cutListGroupMeta: "{{counts}} · {{progress}}",
      cutListGroupProgress: "{{done}}/{{total}} gezaagd",
      cutListGroupProgressSuffix: ", {{done}} van {{total}} gezaagd",
      cutListShow: "Toon",
      cutListShowAll: "Alles",
      cutListShowPending: "Te zagen",
      cutListShowOptionA11y: "{{label}}{{selectedSuffix}}",
      cutProgressLabel: "Zaagvoortgang",
      cutProgressValue: "{{done}}/{{total}} gezaagd",
      cutProgressA11y: "{{done}} van {{total}} onderdelen gezaagd",
      resumeWorkshopEyebrow: "Workshop",
      resumeWorkshop: "Verder op plaat {{sheet}}, zaag {{current}} van {{total}}",
      resumeWorkshopA11y: "Verder in workshop op plaat {{sheet}}, zaag {{current}} van {{total}}",
      resumeWorkshopAction: "Verder",
      showCut: "Toon zaagstap",
      showCutA11y: "Toon zaagstap voor {{name}} in workshopmodus",
      sheetLine: "Plaat {{number}}",
      sheetRest: " (restmateriaal)",
      sheetParts: "{{count}} onderdelen",
      sheetWorkshopHint: "Opent workshopmodus voor deze plaat",
      sheetWorkshopA11y: "Open workshop voor plaat {{number}}, {{parts}} onderdelen{{restSuffix}}{{progressSuffix}}{{lockedSuffix}}{{selectedSuffix}}",
      sheetRowProgressSuffix: ", {{done}} van {{total}} gezaagd",
      sheetRowCompleteSuffix: ", alle onderdelen gezaagd",
      sheetRowA11y: "Plaat {{number}}, {{parts}} onderdelen{{restSuffix}}{{lockedSuffix}}{{selectedSuffix}}",
      sheetRowLockedSuffix: ", simulator vergrendeld",
      sheetRowRestSuffix: " uit restmateriaal",
      sheetRowSelectedSuffix: ", geselecteerd",
      plateRef: "Plaat {{plates}}",
      boardOverview: "Plaatoverzicht",
      boardMeta: "{{count}} onderdelen · {{thickness}} dikte",
      openWorkshopA11y: "Werkplaatsmodus, plaat {{current}} van {{total}}",
      openWorkshopUnlockA11y: "Simulator ontgrendelen, plaat {{current}} van {{total}}",
      openWorkshop: "Werkplaatsmodus",
      openWorkshopUnlock: "Simulator ontgrendelen",
      sheetUnlockHint: "Ontgrendel om alle {{total}} platen stap voor stap te doorlopen.",
      workshopHint: "Loop elke zaagstap naast de zaag door, met overlays en begeleiding per stap.",
      defaultMaterial: "Plaatmateriaal",
      summaryA11y: "{{parts}} onderdelen, {{newSheets}} nieuwe platen{{restSuffix}}, benutting {{utilisation}} procent{{cutSuffix}}",
    },
    import: {
      title: "Project importeren",
      failedTitle: "Import mislukt",
      toProjects: "Naar projecten",
      importing: "Project wordt geïmporteerd…",
      pleaseWait: "Even geduld…",
      projectLimit: "Je kunt maximaal één project bewaren in de gratis versie.",
      defaultName: "Geïmporteerd project",
      notSaved: "Project niet opgeslagen.",
    },
    handoff: {
      emptyLead:
        "Open een link of QR-code vanuit plaatplan.nl, of importeer een projectbestand via de projectlijst.",
      errorLead:
        "Controleer of je nog ruimte hebt in de gratis versie (maximaal 1 project), of probeer opnieuw vanuit de browser.",
    },
    paywall: {
      title: "Werkplaatsmodus ontgrendelen",
      body:
        "Plan gratis op plaatplan.nl. Ontgrendel de app voor meerdere projecten en de volledige simulator naast je zaag.",
      eyebrow: "Werkplaatsmodus",
      sheetTitle: "Verder naar de volgende plaat",
      sheetBody:
        "In de gratis versie doorloop je plaat 1 volledig. Ontgrendel om alle platen stap voor stap te zagen.",
      sheetBodyTarget:
        "Plaat {{next}} van {{total}} staat klaar in je plan. Ontgrendel om elke snede stap voor stap te volgen.",
      sheetPreviewTitle: "Plaat {{next}} van {{total}}, preview",
      sheetPreviewBody:
        "Je ziet het schema. Ontgrendel werkplaatsmodus om elke snede op deze plaat te volgen.",
      sheetCompleteTitle: "Plaat 1 afgerond",
      sheetCompleteBody:
        "Nog {{remaining}} platen klaar in de simulator. Ontgrendel om stap voor stap verder te zagen.",
      sheetCompleteEyebrow: "Plaat 1 klaar",
      webFreeNote: "Plannen en printen op plaatplan.nl blijft gratis, geen abonnement.",
      featureProjects: "Onbeperkt projecten opslaan",
      featureSimulator: "Simulator voor elke plaat",
      featureWorkshop: "Volledige werkplaatsmodus naast de zaag",
      price: "€5,99",
      priceNote: "Eenmalig, geen abonnement",
      unlock: "Ontgrendelen",
      replaceTitle: "Huidig project vervangen?",
      replaceBody:
        "Je kunt maar één project opslaan in de gratis versie. Vervang je huidige project door dit nieuwe project?",
      replaceConfirm: "Vervangen",
      unlockedTitle: "Werkplaatsmodus ontgrendeld",
      unlockedBody:
        "Je kunt nu onbeperkt projecten opslaan en alle platen in de simulator doorlopen.",
      devPreview: "Preview-build: geen echte App Store-aankoop",
      devPreviewNote: "Dev-builds: gebruik DevTools voor preview-unlock. Productie gebruikt App Store / Play billing.",
      sheetLimitHint: "Gratis: simulator alleen voor plaat 1",
      replaceUnlock: "Onbeperkt ontgrendelen",
      sheetSimulatorLocked: "Simulator vergrendeld",
    },
    errors: {
      invalidRecord: "Ongeldig projectrecord.",
      unknownProject: "Project niet gevonden.",
      loadFailed: "Projecten laden mislukt.",
      shareUnavailable: "Delen is niet beschikbaar op dit apparaat.",
    },
    prompt: {
      namePlaceholder: "Naam",
    },
    settings: {
      title: "Instellingen",
      menuA11y: "Instellingen openen, huidig: {{summary}}",
      currentSummary: "{{language}}, {{units}}",
      language: "Taal",
      units: "Eenheden",
      languageNl: "Nederlands",
      languageEn: "English",
      unitsMetric: "Metrisch (mm)",
      unitsImperial: "Imperial (in)",
      workshopMode: "Werkplaatsmodus",
      workshopUnlocked: "Ontgrendeld",
      workshopFree: "Gratis, simulator plaat 1",
      upgradeWorkshop: "Werkplaatsmodus ontgrendelen",
      languageOptionA11y: "{{label}}{{selectedSuffix}}",
      unitsOptionA11y: "{{label}}{{selectedSuffix}}",
      selectedSuffix: ", geselecteerd",
      workshopStatusA11y: "Werkplaatsmodus: {{status}}",
    },
    support: {
      heading: "Steun Plaatplan",
      body:
        "Plan gratis op plaatplan.nl. Met een vrijwillige bijdrage, delen of feedback help je het project, los van je werkplaatsmodus-unlock.",
      share: "Deel Plaatplan",
      shareMessage: "Gratis zaagplanning voor plaatmateriaal, plan op plaatplan.nl",
      shareFailed: "Delen is niet gelukt. Probeer het opnieuw.",
      donate: "Trakteer op een koffie",
      donateUnavailable: "Donatielink is nog niet ingesteld.",
      donateFailed: "Kon de donatiepagina niet openen.",
      feedback: "Geef feedback",
      feedbackFailed: "Kon feedback niet versturen.",
      rateAppStore: "Beoordeel in App Store",
      ratePlayStore: "Beoordeel in Google Play",
      rateUnavailable: "Store-link is nog niet geconfigureerd.",
      rateFailed: "Kon de app store niet openen.",
    },
    feedback: {
      title: "Geef feedback",
      subjectPrefix: "Plaatplan app-feedback",
      privacyNote:
        "We sturen je project niet mee. Alleen dit bericht, de app-versie en het platform (iOS/Android).",
    },
    iap: {
      purchasing: "Aankoop verwerken…",
      restorePurchases: "Aankopen herstellen",
      unavailable: "Aankopen werken niet in Expo Go. Gebruik Instellingen → DevTools → Preview-unlock (dev), of installeer een development build / TestFlight-build voor echte aankopen.",
      nothingToRestore: "Geen eerdere aankoop gevonden voor dit Apple ID of Google-account.",
      purchaseFailed: "Aankoop mislukt. Probeer opnieuw of herstel een eerdere aankoop.",
      restoreSuccessTitle: "Aankoop hersteld",
      restoreSuccessBody: "Werkplaatsmodus is weer ontgrendeld op dit toestel.",
      restoreEmptyTitle: "Niets te herstellen",
      restoreEmptyBody: "We vonden geen werkplaatsmodus-unlock voor dit account.",
    },
    onboarding: {
      skip: "Overslaan",
      skipA11y: "Introductie overslaan",
      next: "Volgende",
      back: "Terug",
      stepLabel: "{{current}} / {{total}}",
      stepA11y: "Introductiestap {{current}} van {{total}}",
      welcomeIllustrationA11y: "Illustratie van een plaatindeling met gemarkeerde zaagstap en zaaglijst",
      preferencesIllustrationA11y: "Illustratie van taal- en eenheidsinstellingen",
      workflowIllustrationA11y: "Illustratie van plannen op het web, JSON exporteren en importeren in de app",
      getStartedIllustrationA11y: "Illustratie van voorbeeldplan en importopties",
      welcome: {
        eyebrow: "Plaatplan Werkplaats",
        title: "Zaaglijst en begeleiding naast de zaag",
        body:
          "Plan thuis je zaagindeling op het web, en gebruik deze app in de werkplaats voor je zaaglijst, plaatoverzicht en stap-voor-stap simulator.",
        featureCutList: "Zaaglijst per dikte met plaatreferenties",
        featureBoard: "Visueel plaatoverzicht met zaagvolgorde",
        featureWorkshop: "Werkplaatsmodus begeleidt elke zaagstap",
      },
      preferences: {
        title: "Taal & eenheden",
        body: "Kies hoe maten en teksten worden getoond. Je kunt dit later wijzigen via instellingen.",
      },
      workflow: {
        title: "Zo werkt het",
        body:
          "De meeste gebruikers plannen op de gratis web-planner en importeren het project hier. Je kunt ook beginnen met het ingebouwde voorbeeldplan.",
        stepLabel: "Stap {{step}}",
      },
      getStarted: {
        title: "Aan de slag",
        body:
          "Probeer het voorbeeldplan om projectdetails te verkennen, of ga naar je projectlijst om een bestand van plaatplan.nl te importeren.",
        tryDemo: "Probeer voorbeeldplan",
        toProjects: "Naar projecten",
        demoCardTitle: "Voorbeeldplan",
        demoCardBody: "Bekijk platen, onderdelen en zaagplan",
        importCardTitle: "Later importeren",
        importCardBody: "Project van de web-planner binnenhalen",
      },
    },
    workshop: {
      close: "Sluiten",
      closeA11y: "Werkplaatsmodus sluiten",
      backA11y: "Terug naar project",
      progressA11y: "Voortgang stap {{current}} van {{total}}",
      previous: "Vorige",
      next: "Volgende",
      done: "Klaar",
      finishSheet: "Plaat afronden",
      finishSheetA11y: "Rond deze plaat af en ga terug naar het project",
      continueNextSheet: "Ga door naar volgende plaat",
      continueNextSheetA11y: "Ga door naar de volgende plaat",
      doneA11y: "Rond de werkplaatsmodus af en ga terug naar het project",
      back: "Terug",
      rotateHint: "Draai je toestel voor de werkplaatsmodus.",
      dismissRotateHintA11y: "Draai-hint sluiten",
      swipeHint: "Veeg links of rechts op het bord voor de vorige of volgende snede.",
      swipeHintA11y: "Veeg op het bord of gebruik de knoppen onderaan om tussen zaagstappen te wisselen.",
      headerA11y: "{{name}}, plaat {{current}} van {{total}}",
      currentStepA11y: "Huidige zaagstap: {{title}}",
      unavailable: "Werkplaatsmodus niet beschikbaar voor dit project.",
      noCuts: "Geen zaagsneden om te simuleren op deze plaat.",
      previousSheet: "Vorige plaat",
      nextSheet: "Volgende plaat",
      sheetOf: "Plaat {{current}} / {{total}}",
      sheetMeta: "Plaat {{current}} van {{total}} · {{size}}",
      previousSheetA11y: "Vorige plaat",
      nextSheetA11y: "Volgende plaat",
      sheetA11y: "Plaat {{current}} van {{total}}",
      stepProgress: "{{label}} / {{max}}",
      cutStepA11y: "Zaagstap",
      markAllCut: "Markeer alle onderdelen als gezaagd",
      markAllCutA11y: "Markeer alle onderdelen op deze plaat als gezaagd in de zaaglijst",
      markAllCutDone: "Alle onderdelen gemarkeerd als gezaagd",
      markAllCutDoneA11y: "Alle onderdelen op deze plaat zijn gemarkeerd als gezaagd in de zaaglijst",
    },
  },
  workshop: {
    orientation: {
      horizontal: "horizontaal",
      vertical: "verticaal",
    },
    orientationCap: {
      horizontal: "Horizontale",
      vertical: "Verticale",
    },
    span: {
      length: "lengte",
      width: "breedte",
    },
    caption: {
      start: "Start: volledige plaat op de zaag.",
      stripRip: "{{orientation}} strook-snede op {{position}}",
      stripCross: "Dwars afkorten op {{position}}",
      fullLine: "{{orientation}} snede op {{position}} over volledige {{span}}",
      partial: "{{orientation}} snede op {{position}}",
    },
    start: {
      detail: "Loop de genummerde snedes door naast de zaag.",
    },
    complete: {
      title: "Alle sneden voltooid",
      detail: "Controleer de onderdelen op maat en leg bruikbare zaagresten apart.",
    },
    cut: {
      stripRip: "Zaag een strook af op {{position}} ({{orientation}})",
      stripCross: "Kort de strook dwars af op {{position}}",
      fullLine: "Zaag {{orientation}} op {{position}} over de volledige plaat",
      partial: "Zaag {{orientation}} op {{position}}",
    },
    detail: {
      workPiece: "Werk op het gemarkeerde stuk ({{size}}).",
      afterVertical: "Na deze snede: {{first}} links en {{second}} rechts.",
      afterHorizontal: "Na deze snede: {{first}} boven en {{second}} onder.",
    },
    stepLabel: {
      start: "Start",
      done: "Klaar",
      cut: "Snede {{current}} / {{max}}",
      progressCut: "Snede {{current}}",
    },
  },
  core: coreNl,
  web: {
    shell: {
      skipLink: "Ga naar inhoud",
      srTitle: "Plaatplan: gratis zaagplan maken voor plaatmateriaal",
      eyebrow: "Gratis zaagplan",
      closeNotice: "Sluiten",
    },
    seo: {
      defaultTitle: "Plaatplan | Gratis zaagplan maken voor MDF en multiplex",
      defaultDescription:
        "Maak gratis een zaagplan voor MDF, multiplex, spaanplaat en meubelpaneel. Plaatplan deelt je panelen in op standaardplaten, telt hoeveel platen je nodig hebt en levert een werkplan met zaaglijst voor de bouwmarkt of zaagservice.",
      ogImageAlt:
        "Plaatplan: zaagindeling op een plaat met panelen en resultaat met aantal platen en benutting",
      shareText: "Gratis zaagplanning voor plaatmateriaal: MDF, multiplex en meer.",
      feedbackSubjectPrefix: "Plaatplan feedback",
      features: [
        "Zaagplan maken voor plaatmateriaal",
        "Meerdere deelprojecten in één plan",
        "Zaagindeling met kerf en nerfrichting",
        "Zaaglijst exporteren als PDF of CSV",
        "Lokaal opgeslagen zonder account",
      ],
    },
    feedback: {
      typeBug: "Bug of fout",
      typeIdea: "Idee of verbetering",
      typeQuestion: "Vraag",
      typeOther: "Iets anders",
      topicLabel: "Waar gaat het over?",
      messageLabel: "Je bericht",
      messagePlaceholder:
        "Bijvoorbeeld: bij restmateriaal zie ik niet waarom een plaat niet wordt gebruikt.",
      emailLabel: "E-mail (optioneel)",
      emailPlaceholder: "Alleen invullen als je antwoord wilt",
      privacyNote: "We sturen je plan niet mee. Alleen dit bericht en de pagina waar je bent.",
      submit: "Feedback versturen",
      submitting: "Versturen…",
      successTitle: "Bedankt voor je feedback.",
      successBody:
        "We lezen elk bericht. Als je je e-mail hebt ingevuld, proberen we te antwoorden.",
      sendAnother: "Nog een bericht sturen",
      errorUnavailable: "Feedback versturen is nu niet mogelijk. Probeer het later opnieuw.",
      errorEmpty: "Schrijf kort wat je wilt melden.",
      errorSendFailed: "Versturen lukte niet. Probeer het later opnieuw.",
    },
    siteHeader: {
      brandAria: "Plaatplan, naar de planner",
      openPlanner: "Open planner",
    },
    footer: {
      tagline: "Zaagplanning voor plaatmateriaal. Meerdere projecten, één werkplan met zaaglijst.",
      seoSummary: "Wat is een zaagplan?",
      seoText:
        "Een zaagplan (of zaagschema) toont hoe onderdelen op MDF, multiplex, spaanplaat of meubelpaneel liggen, met kerf, nerfrichting en restmateriaal. De zaaglijst bevat de zaagmaten en aantallen voor de zaagbalie. Plaatplan helpt je panelen in te delen, berekent hoeveel platen je nodig hebt en levert een printbaar werkplan.",
      guides: "Gidsen",
      handbook: "Handleiding",
      info: "Informatie",
      supportRegion: "Steun Plaatplan",
      supportTitle: "Vond je Plaatplan nuttig?",
      supportText:
        "Steun het project vrijwillig met een bijdrage, door te delen of feedback te geven.",
      supportTextWithApp:
        "De web-planner blijft gratis. Steun het project met een bijdrage, door te delen, feedback te geven, of probeer werkplaatsmodus in de app.",
      supportButton: "Steun Plaatplan",
      copyright: "© {{year}} Plaatplan",
      freeInBrowser: "Gratis in je browser",
      noAccount: "Geen account nodig",
      preferences: "Taal & eenheden",
      infoLinks: {
        about: "Waarom Plaatplan",
        faq: "Veelgestelde vragen",
        feedback: "Feedback",
        privacy: "Privacy",
        disclaimer: "Disclaimer",
      },
    },
    guides: {
      nav: {
        how: "Hoe het werkt",
        werkplanExport: "Werkplan printen",
        cutSimulator: "Zaagvolgorde controleren",
        importExport: "Importeren en exporteren",
      },
      kicker: "Handleiding",
      toPlanner: "Naar de planner",
      readMore: "Lees verder in de handleiding",
      related: {
        werkplanBefore: "Zaagvolgorde stap voor stap? Lees de",
        werkplanAfter: "Nog geen plan? Begin in de",
        werkplanOrRead: "of lees",
        simulatorBefore: "Meer over het werkplan? Lees",
        simulatorAfter: "of begin in de",
        planner: "planner",
      },
    },
    landing: {
      howItWorks: "Zo werkt Plaatplan",
      faq: "Veelgestelde vragen",
      preview: {
        title: "Voorbeeld uit de planner",
        intro:
          "Plaat {{sheetNumber}} van het demoplan (Commode, Bureau en Kast op MDF {{length}} × {{width}} mm). Panelen zijn kleurgecodeerd per deelproject.",
        caption:
          "Het volledige demoplan: {{sheets}} platen, {{parts}} onderdelen, {{utilisation}}% benutting (inclusief kerf).",
      },
      nav: {
        "zaagplan-maken": "Zaagplan maken",
        "zaagplan-mdf": "Zaagplan MDF",
        "zaagplan-multiplex": "Zaagplan multiplex",
        "zaagplan-spaanplaat": "Zaagplan spaanplaat",
        "zaagplan-meubelpaneel": "Zaagplan meubelpaneel",
        "bouwmarkt-zaagplan": "Bouwmarkt zaagplan",
        zaagindeling: "Zaagindeling",
      },
    },
    supportModal: {
      kicker: "Steun het project",
      title: "Steun Plaatplan",
      intro1:
        "Plaatplan heeft twee delen: gratis zaagplanning in je browser, en een optionele app voor werkplaatsmodus naast de zaag.",
      intro2:
        "De web-planner blijft gratis, zonder account of abonnement. Als Plaatplan je heeft geholpen, kun je het project op verschillende manieren steunen.",
      webHeading: "Gratis web-planner",
      webNote:
        "Plannen, zaagindeling, werkplan en export blijven gratis in je browser. Dat verandert niet als je de app gebruikt.",
      monetaryHeading: "Vrijwillige bijdrage",
      monetaryNote:
        "Een donatie helpt Plaatplan draaiende houden. Betalen gebeurt buiten Plaatplan, in een nieuw tabblad.",
      appHeading: "Werkplaatsmodus (app)",
      appNote:
        "De app is een eenmalige aankoop voor de volledige simulator en meerdere projecten, geen abonnement. Je kunt eerst gratis plaat 1 proberen.",
      appStoreLabel: "Download voor iPhone / iPad",
      appStoreHint: "App Store, eenmalige unlock voor werkplaatsmodus.",
      playStoreLabel: "Download voor Android",
      playStoreHint: "Google Play, eenmalige unlock voor werkplaatsmodus.",
      appComingSoon: "De app verschijnt binnenkort in de stores. Exporteer je project als JSON om het later te importeren.",
      communityHeading: "Deel of geef feedback",
      shareLabel: "Deel Plaatplan",
      shareHint: "Vertel een klusmaat of in een DIY-groep over de gratis web-planner.",
      feedbackLabel: "Geef feedback",
      feedbackHint: "Bug, idee of compliment, ook over de app als je die gebruikt.",
      shareStatusShared: "Bedankt voor het delen!",
      shareStatusCopied: "Link gekopieerd naar je klembord.",
      shareStatusUnsupported: "Kopiëren is hier niet mogelijk. Deel handmatig: plaatplan.nl",
      dismiss: "Niet nu",
      options: {
        tikkie: { label: "Trakteer op een koffie", hint: "Kleine bijdrage via Tikkie." },
        mollie: { label: "Doneer via iDEAL", hint: "Vast of vrij bedrag via Mollie." },
        github: { label: "GitHub Sponsors", hint: "Eenmalig of maandelijks via GitHub." },
      },
    },
    actions: {
      import: "Importeren",
      export: "Exporteren",
      loadDemo: "Demo laden",
      resetPlan: "Leeg plan starten",
    },
    sections: {
      optimization: "Optimalisatie",
      layout: "Zaagindeling",
      subprojects: "Deelprojecten",
      partsList: "Onderdelenlijst",
      result: "Resultaat",
      standardSheet: "Standaardplaat",
      materialStock: "Materiaalvoorraad",
      restStock: "Restmateriaal",
      project: "Project",
    },
    plan: {
      nameLabel: "Plannaam",
    },
    source: {
      quickPresetsLegend: "Snel kiezen",
      quickPresetsHint: "Veelgebruikte combinaties uit de bouwmarkt.",
      defaultThicknessLabel: "Standaarddikte",
      defaultThicknessPresets: "Veelgebruikte standaarddiktes",
      sheetSizeLegend: "Formaat",
      moreMaterials: "Meer materialen",
      moreStandardFormats: "Meer standaardformaten",
      sawSettingsLegend: "Zaaginstellingen",
      sawGrainLegend: "Zaag & nerf",
      kerfLabel: "Zaagbreedte",
      marginLabel: "Randmarge",
      kerfHint: "De indeling houdt rekening met de zaagbreedte. Standaard 2,2 mm.",
      grainNone: "Geen nerf, vrij draaien",
      grainFixedOption: "Nerf vast op de plaat",
      grainFixedHint:
        "Panelen blijven in de ingevoerde richting; geen 90°-draai. Gebruik bij zichtbaar multiplex.",
      grainFreeHint: "Geschikt voor MDF en spaanplaat zonder zichtbare nerf.",
      rotationHint: "Meestal aan bij MDF. Uitgeschakeld zolang nerfrichting vast staat.",
      grainLabel: "Nerfrichting",
      rotationLabel: "Panelen mogen 90° draaien",
    },
    fields: {
      length: "Lengte",
      width: "Breedte",
      thickness: "Dikte",
      quantity: "Aantal",
      unitMm: "mm",
      unitIn: "in",
      thicknessOption: "{{value}} mm",
    },
    materialStock: {
      scopeNote:
        "Eén materiaaltype per plan. Diktes mogen per onderdeel verschillen; twee materialen combineren kan niet in hetzelfde plan.",
      scopeNoteBeforeMaterial: "Eén materiaaltype per plan, huidige keuze:",
      scopeNoteAfterMaterial:
        ". Diktes mogen per onderdeel verschillen; twee materialen (bijv. MDF en multiplex) niet combineren.",
      summaryCollapsed: "Plaat & restmateriaal instellen",
    },
    restStock: {
      introEmpty:
        "Zelfde materiaal als de standaardplaat hierboven. Nog geen restmateriaal; voeg een stuk {{material}} toe dat je wilt hergebruiken.",
      introWithItems:
        "Zelfde materiaal als de standaardplaat hierboven. Per stuk kies je de dikte. De planner gebruikt restmateriaal vóór nieuwe standaardplaten.",
      labelDescription: "Omschrijving",
      placeholderDescription: "Bijv. rest links",
      removeA11y: "Restmateriaal verwijderen",
      removeConfirm: "Klik nogmaals om “{{label}}” te verwijderen",
      removeFallbackLabel: "restmateriaal",
      addButton: "+ Restmateriaal toevoegen",
    },
    planMetrics: {
      addParts: "Voeg onderdelen toe om een indeling te berekenen.",
      invalidSingular: "{{count}} onderdeel past niet op de beschikbare platen.",
      invalidPlural: "{{count}} onderdelen passen niet op de beschikbare platen.",
      notCalculated: "Nog geen indeling berekend.",
      restOnlySingular: "Past volledig op restmateriaal ({{count}} stuk).",
      restOnlyPlural: "Past volledig op restmateriaal ({{count}} stukken).",
      mixedSingular:
        "Past op {{newCount}} nieuwe standaardplaat en {{restCount}} restmateriaalstuk.",
      mixedPlural:
        "Past op {{newCount}} nieuwe standaardplaten en {{restCount}} restmateriaalstukken.",
      oneSheet: "Alles past op 1 standaardplaat.",
      multipleSheets: "Past op {{count}} standaardplaten.",
    },
    confirm: {
      confirm: "Bevestigen",
      reset: {
        title: "Leeg plan starten",
        message: "Weet je zeker dat je een leeg plan wilt starten? Je huidige plan wordt overschreven.",
        confirmLabel: "Leeg plan starten",
      },
    },
    presets: {
      combined: {
        mdf18Full: { label: "MDF 18 mm", hint: "2440 × 1220" },
        mdf18Half: { label: "MDF 18 mm", hint: "1220 × 610" },
        spaan18Half: { label: "Spaanplaat 18", hint: "1220 × 610" },
        meubelpaneel18Full: { label: "Meubelpaneel 18", hint: "2440 × 1220" },
      },
      material: {
        mdf18: { label: "MDF 18 mm", hint: "Meest gebruikt", materialName: "MDF plaat 18 mm" },
        mdf15: { label: "MDF 15 mm", hint: "Lichter", materialName: "MDF plaat 15 mm" },
        mdf12: { label: "MDF 12 mm", materialName: "MDF plaat 12 mm" },
        mdf9: { label: "MDF 9 mm", hint: "Achterwanden", materialName: "MDF plaat 9 mm" },
        multiplex18: { label: "Multiplex 18", hint: "Berken", materialName: "Multiplex berk 18 mm" },
        multiplex15: { label: "Multiplex 15", materialName: "Multiplex berk 15 mm" },
        multiplex12: { label: "Multiplex 12", materialName: "Multiplex berk 12 mm" },
        multiplex9: { label: "Multiplex 9", hint: "Achterwanden", materialName: "Multiplex berk 9 mm" },
        spaan18: { label: "Spaanplaat 18", hint: "Budget", materialName: "Spaanplaat 18 mm" },
        spaan15: { label: "Spaanplaat 15", materialName: "Spaanplaat 15 mm" },
        spaan12: { label: "Spaanplaat 12", materialName: "Spaanplaat 12 mm" },
        meubelpaneel18: {
          label: "Meubelpaneel 18",
          hint: "Melamine / decor",
          materialName: "Meubelpaneel 18 mm",
        },
      },
      sheet: {
        full: { label: "2440 × 1220", hint: "Hele plaat" },
        half: { label: "1220 × 610", hint: "Halve plaat" },
        large: { label: "2500 × 1250", hint: "Groot formaat" },
        panel: { label: "1830 × 750", hint: "Paneel" },
      },
    },
    save: {
      autoSavedPrefix: "Automatisch opgeslagen,",
      autoSavedStatus: "Automatisch opgeslagen, {{time}}",
    },
    empty: {
      title: "Nog geen zaagplan",
      copy:
        "Voeg onderdelen toe in een deelproject, of bekijk eerst het voorbeeld met drie meubels op één plan.",
      featureKerf: "Inclusief zaagbreedte (kerf)",
      featurePdf: "Exporteer daarna als PDF",
      hint: "Commode · Bureau · Kast, MDF 2440 × 1220 mm",
    },
    result: {
      sheetsGroupLabel: "Benodigde platen",
      newSheet: "Nieuwe standaardplaat",
      newSheets: "Nieuwe standaardplaten",
      restPiece: "stuk restmateriaal",
      restPieces: "stukken restmateriaal",
      utilisationLabel: "Benutting",
      utilisationPercent: "{{value}} procent",
      utilisationValue: "{{value}}% benutting",
      utilisationHint: "Hoe hoger, hoe minder rest op je platen.",
      parts: "{{count}} onderdelen",
      partsSuffix: "onderdelen",
      areaSuffix: "oppervlak",
      thicknessLabel: "Verdeling per dikte",
      thicknessNew: "{{count}} nieuw",
      thicknessRest: "{{count}} rest",
      invalid: "{{count}} onderdeel(en) passen niet.",
    },
    settings: {
      title: "Taal & eenheden",
      menuLabel: "Instellingen",
      menuA11y: "Instellingen openen, huidig: {{summary}}",
      intro: "Kies de taal van de interface en hoe afmetingen worden getoond.",
      currentSummary: "{{language}} · {{units}}",
      language: "Taal",
      units: "Eenheden",
      languageNl: "Nederlands",
      languageEn: "English",
      unitsMetric: "Metrisch (mm)",
      unitsImperial: "Imperial (in)",
    },
    messages: {
      demoLoaded: "Demo geladen: {{names}}.",
      csvDownloaded: "Zaaglijst gedownload als CSV.",
      projectDownloaded: "Projectbestand gedownload.",
      importSuccess: "Zaagplan geïmporteerd.",
      importFailed: "Importeren mislukt: {{message}}",
      resetStarted: "Leeg plan gestart.",
    },
    board: {
      unusedTitle: "Restmateriaal niet gebruikt",
      sheetTitle: "Plaat {{number}}",
      restBadge: "Restmateriaal",
      unusedBadge: "Niet gebruikt",
      sheetMeta: "{{thickness}} dik · plaat {{index}} van deze dikte",
      longAxis: "lange zijde ({{size}})",
      shortAxis: "brede zijde ({{size}})",
    },
    sheetTab: {
      listLabel: "Bronplaten",
      unused: "Niet gebruikt",
      rest: "Rest",
      sheet: "Plaat",
    },
    layout: {
      footnote: "Kleuren tonen het deelproject; panelen worden alleen gecombineerd binnen dezelfde dikte.",
    },
    subproject: {
      addRegion: "Deelproject toevoegen",
      addTitle: "Deelproject toevoegen",
      kicker: "Nieuw deelproject",
      hint: "Groepeer onderdelen per meubel of klus. Daarna voeg je panelen toe in dat project.",
      placeholder: "Bijv. Bureau, Kast, Commode",
      addButton: "+ Deelproject",
      nameRequired: "Geef het deelproject een naam, bijvoorbeeld Bureau of Kast.",
      defaultName: "Project {{number}}",
    },
    panels: {
      unnamedPanel: "Naamloos paneel",
      unnamedProject: "Naamloos project",
      defaultPanelName: "paneel",
      panelDefaultName: "Paneel",
      copySuffix: "kopie",
      projectNameAria: "Deelprojectnaam",
      hiddenCount: "{{count}} verborgen",
      color: "Kleur",
      colorTitle: "Projectkleur",
      remove: "Verwijderen",
      empty: "Nog geen panelen in dit project.",
      rowLabel: "rij {{number}}",
      panelNumber: "Paneel {{number}}",
      namePlaceholder: "Bijv. linker deur",
      hiddenOnSheet: "verborgen",
      edgeSidesSingular: "{{count}} zijde",
      edgeSidesPlural: "{{count}} zijden",
      defineEdges: "Bepaal afwerkingen",
      showInLayout: "Tonen in zaagindeling",
      hideFromLayout: "Verbergen uit zaagindeling",
      duplicate: "Paneel dupliceren",
      delete: "Paneel verwijderen",
      deleteConfirm: "Klik nogmaals om “{{name}}” te verwijderen",
      columns: {
        number: "Nummer",
        name: "Naam paneel",
        length: "Lengte ({{unit}})",
        width: "Breedte ({{unit}})",
        thickness: "Dikte ({{unit}})",
        quantity: "Aantal",
        sheet: "# Plaat",
        edges: "Afwerkingen zijkanten",
        edgeFinishing: "Afwerkingen",
        actions: "Acties",
      },
      aria: {
        name: "Naam paneel, {{row}}",
        length: "Lengte in {{unit}}, {{row}}",
        width: "Breedte in {{unit}}, {{row}}",
        thickness: "Dikte in {{unit}}, {{row}}",
        quantity: "Aantal, {{row}}",
      },
    },
    edgeModal: {
      title: "Kantafwerking",
      sides: {
        top: "Bovenzijde",
        right: "Rechterzijde",
        bottom: "Onderzijde",
        left: "Linkerzijde",
      },
    },
    parsePartLine: {
      empty: "Voer een onderdeel in, bijvoorbeeld 600x1220x2 zijpaneel.",
      emptyImperial: "Voer een onderdeel in, bijvoorbeeld 24 1/2 x 12 x 2 plank.",
      invalidFormat: "Formaat: lengte x breedte x aantal + naam (aantal en naam zijn optioneel).",
      invalidFormatImperial: "Formaat: lengte x breedte x aantal + naam, bijv. 24 1/2 x 12 x 2 plank of 2' 6\" x 1' 4\".",
      lengthMin: "Lengte moet minimaal {{min}} zijn.",
      widthMin: "Breedte moet minimaal {{min}} zijn.",
      quantityMin: "Aantal moet een geheel getal van 1 of hoger zijn.",
      understood: "Begrepen:",
      preview: "{{size}} × {{quantity}} stuks{{nameSuffix}}",
      inputAria: "Snel paneel invoeren in {{project}}",
      placeholder: "600x1220x2 zijpaneel",
      placeholderImperial: "24 1/2 x 12 x 2 plank",
      addPanel: "+ Paneel",
      addEmpty: "Leeg paneel toevoegen",
    },
    a11y: {
      unusedSummary: "Restmateriaal niet gebruikt",
      sheetSummary: "Tekstuele indeling plaat {{number}}",
      panelsOnSheet: "Panelen op plaat {{number}}",
      rotated: ", 90° gedraaid",
      position: "; positie {{position}} vanaf linkerbovenhoek",
    },
    export: {
      openWerkplan: "Werkplan openen",
      openWerkplanHint: "Zaaglijst, strategie en print als PDF",
      materialSummary: "Wat heb ik nodig",
      materialSummaryHint: "Materiaaloverzicht voor de winkel",
      cutListCsv: "Zaaglijst (CSV)",
      cutListCsvHint: "Spreadsheet voor e-mail of Excel",
      projectBackup: "Projectbestand",
      projectBackupHint: "Backup downloaden (.json)",
      workshopHandoff: "Naar werkplaats (app)",
      workshopHandoffHint: "QR-code of link voor tablet/telefoon",
      emptyPlanNote: "Voeg eerst onderdelen toe om een werkplan te exporteren.",
    },
    materialSummary: {
      kicker: "Inkoopoverzicht",
      title: "Wat heb ik nodig?",
      intro:
        "Neem dit overzicht mee naar de bouwmarkt of zaagservice. Het telt alleen panelen die meedoen in de zaagindeling.",
      stats: {
        newSheet: "nieuwe standaardplaat",
        newSheets: "nieuwe standaardplaten",
        fromRestStock: "uit restmateriaal",
        parts: "onderdelen",
        utilisation: "benutting",
      },
      invalidSingular:
        "{{count}} onderdeel past niet op de gekozen standaardplaat. Los dit op vóór je materiaal bestelt.",
      invalidPlural:
        "{{count}} onderdelen passen niet op de gekozen standaardplaat. Los dit op vóór je materiaal bestelt.",
      material: {
        title: "Materiaal",
        plan: "Plan",
        material: "Materiaal",
        standardSheet: "Standaardplaat",
        kerf: "Zaagbreedte",
        margin: "Randmarge",
      },
      order: {
        title: "Te bestellen",
        empty: "Voeg onderdelen toe om een materiaaloverzicht te berekenen.",
        thickness: "Dikte",
        newSheets: "Nieuwe platen",
        restStock: "Restmateriaal",
        parts: "Onderdelen",
        sheetSize: "Formaat per plaat",
        partsCount: "{{count}} stuks",
        orderPrefix: "Bestel:",
        orderItem: "{{count}}× {{material}} ({{size}})",
        restStockLine: "Uit restmateriaal:",
        restStockSingular: "{{count}} stuk",
        restStockPlural: "{{count}} stukken",
      },
      subprojects: {
        title: "Deelprojecten",
        parts: "{{count}} onderdelen",
      },
      tip: {
        title: "Tip",
        body:
          "Open daarna Exporteren → Werkplan openen voor de volledige zaaglijst met maten, kantafwerking en zaaginstructies.",
      },
    },
    mobileAppPromo: {
      eyebrow: "Plaatplan app",
      werkplan: {
        titlePhone: "Zaag je zelf? Neem je plan mee naar de werkplaats",
        titleTablet: "Werkplaatsmodus op tablet of telefoon",
        bodyPhone:
          "Op je telefoon zie je hier alleen het plaatschema. In de Plaatplan app loop je elke zaagsnede stap voor stap na naast de zaag.",
        bodyTablet:
          "Plan gratis op het web, gebruik de app in de schuur voor zaaglijst, plaatoverzicht en een stap-voor-stap simulator.",
      },
      simulator: {
        title: "Stap-voor-stap zaagbegeleiding",
        body:
          "De interactieve zaagvolgorde werkt op een groot scherm. In de Plaatplan app volg je elke snede fullscreen naast je zaagmachine.",
      },
      planner: {
        title: "Verder in de werkplaats",
        body:
          "Plan hier gratis. Importeer je project in de Plaatplan app voor werkplaatsmodus: zaaglijst, platen wisselen en simulator naast de zaag.",
      },
      guide: {
        how: {
          title: "Plan gratis, zaag in de app",
          body:
            "Gebruik Plaatplan in je browser om te plannen en te printen. Als je gaat zagen, importeer je hetzelfde project in de app voor werkplaatsmodus.",
        },
        werkplanExport: {
          title: "Meenemen naar de werkplaats",
          body:
            "Print het werkplan voor de bouwmarkt, of open hetzelfde project in de Plaatplan app voor een stap-voor-stap simulator naast je zaag.",
        },
        cutSimulator: {
          title: "Stap voor stap aan de zaag",
          body:
            "De zaagvolgorde op het web helpt je thuis voorbereiden. In de app volg je elke snede fullscreen in werkplaatsmodus.",
        },
        importExport: {
          title: "Zelfde projectbestand, offline in de schuur",
          body:
            "Exporteer een .json-back-up vanuit de planner en importeer die in de Plaatplan app. Zelfde formaat, klaar voor werkplaatsmodus zonder account.",
        },
      },
      steps: {
        plan: "Plan op plaatplan.nl (gratis)",
        send: "Stuur naar je telefoon of tablet",
        workshop: "Zaag stap voor stap in werkplaatsmodus",
      },
      handoff: "Naar app (QR of link)",
      dismiss: "App-promo 24 uur verbergen",
      appStore: "App Store",
      playStore: "Google Play",
      note: "Gratis proberen: één project en plaat 1 in de simulator. Geen abonnement.",
    },
    workshopHandoff: {
      title: "Naar de werkplaats",
      lead:
        "Scan de QR-code met je tablet of telefoon, of tik op Open in Plaatplan als de app al op hetzelfde toestel staat.",
      close: "Sluiten",
      qrAlt: "QR-code om het project in de Plaatplan app te openen",
      qrLoading: "QR-code laden…",
      openInApp: "Open in Plaatplan",
      copyLink: "Kopieer link",
      linkCopied: "Link gekopieerd",
      copyFailed: "Kopiëren mislukt. Gebruik de QR-code of Open in Plaatplan.",
      note:
        "Werkt op iPad en telefoon met de Plaatplan app geïnstalleerd. Het project wordt automatisch geïmporteerd.",
    },
    exportBoard: {
      sheetTitle: "Plaat {{number}}",
      offcutLabel: {
        default: "ZAAGREST",
        selfTrim: "ZELF AF TE KORTEN",
      },
      stripBanner: {
        noCrosscut: "STROKEN HEEL LEVEREN. NIET OP LENGTE AFKORTEN",
        crosscut: "STROKEN LEVEREN, DAARNA AFKORTEN OP ZAAGMAAT",
      },
      placementCaption: {
        stripSelfTrim: "ZAAGMAAT: zelf afkorten uit strook",
      },
      cutSummary: {
        countSingular: "1 zaagsnede",
        countPlural: "{{count}} zaagsneden",
        strips: "stroken",
        preserve: "rest bewaren",
        efficient: "efficiënt",
      },
      printSummary: {
        stripsDeliver: "Lever als volledige strook: {{sizes}}.",
        stripsDefault: "Lever als volledige stroken; niet op lengte afkorten.",
        stripsTrimTo: "Zelf af te korten naar: {{sizes}}.",
        stripsSelfCut: "Verwacht zelf af te korten: {{sizes}}.",
        preservePrimary: "Indien praktisch één primair stuk zaagrest meegeven: circa {{size}}.",
        preserveGeneric: "Indien praktisch grotere stukken zaagrest behouden en meegeven.",
        efficient: "Efficiënt zagen volgens de zaagmaten in de zaaglijst.",
      },
    },
    werkplan: {
      backToApp: "Terug naar app",
      printPdf: "Print / sla op als PDF",
      kickerPrepare: "Stap 1: Voorbereiden",
      kickerShop: "Stap 2: Zaagopdracht",
      title: "Zaaglijst en werkplan",
      subtitlePrepare:
        "Kies welke platen meegaan, stel zaaginstellingen in en controleer de zaaglijst. Ga daarna naar stap 2.",
      subtitleShop: "Dit neem je mee naar de zaagwinkel. Aanpassen kan in stap 1.",
      subtitlePrint:
        "Zaagopdracht. De zaagmaten in dit document zijn leidend. Graag controleren of de opdracht uitvoerbaar is.",
      facts: {
        date: "Datum",
        project: "Project",
        material: "Materiaal",
        standardSheet: "Standaardplaat",
        kerf: "Zaagbreedte",
        margin: "Randmarge",
        cutLists: "Zaaglijsten",
        thicknessCount: "{{count}} diktes",
      },
      tabs: {
        listLabel: "Werkplan stappen",
        prepare: "Voorbereiden",
        shop: "Zaagopdracht",
      },
      visualLayout: {
        title: "Visuele zaagindeling",
        prepareNote:
          "Stel per plaat de strategie in en controleer de indeling. De tab Zaagopdracht toont wat je aan de winkel geeft.",
        shopNote: "Optioneel ter ondersteuning. De zaaglijst hierboven is leidend voor de maten.",
        sheetStrategyTitle: "Plaat {{number}}: zaagstrategie",
        strategyForSheet: "Strategie voor deze plaat",
        inheritStrategy: "Gebruik algemene strategie",
        notPossible: " (niet mogelijk)",
        deviationBanner: "Afwijkend van algemeen:",
        stripRequested: "Gevraagd:",
        stripShownAs: "Getoond en geëxporteerd als:",
        offcutStripSelfCut: "Deel dat jij later van de volledige strook afkort",
        offcutPotential: "Potentieel mee te geven zaagresten",
        offcutApprox: "circa {{size}} ({{label}})",
        sheetNoteLabel: "Extra notitie bij plaat {{number}}",
        sheetNotePlaceholder:
          "Bijvoorbeeld: eerst lange stroken zagen; controleren op beschadigde rand.",
        sheetPrintPrefix: "Plaat {{number}}:",
        remark: "Opmerking:",
      },
      shop: {
        generalInstruction: "Algemene instructie",
        control: "Controle",
      },
      alert: {
        title: "Belangrijk voor het zagen",
        dimensionsMetric: "Alle afmetingen zijn in millimeters.",
        dimensionsImperial: "Afmetingen worden getoond in inches.",
        cutColumns:
          "De kolommen Zaagmaat lengte en Zaagmaat breedte zijn de maten waarop gezaagd moet worden.",
        kerfInCalculation: "Zaagbreedte in berekening: {{kerf}}",
        multipleThicknesses:
          "Panelen met verschillende dikte staan in aparte zaaglijsten en worden apart gezaagd.",
        restExcluded:
          "Restmateriaal valt buiten deze zaagopdracht. Alleen onderdelen op nieuwe standaardplaten staan in de zaaglijst.",
        newSheetsExcluded:
          "Nieuwe standaardplaten vallen buiten deze zaagopdracht. Alleen onderdelen op restmateriaal staan in de zaaglijst.",
        zeroKerfWarning:
          "Let op: er is gerekend zonder zaagbreedte. Controleer of de zaagservice hiervoor marge moet rekenen.",
      },
      materialOverview: {
        title: "Materiaaloverzicht",
        empty: "Voeg onderdelen toe om een materiaaloverzicht te tonen.",
        material: "Materiaal",
        sourceSize: "Bronformaat",
        newSheets: "Nieuwe platen",
        restStock: "Restmateriaal",
      },
      materialScope: {
        title: "Wat neem je mee in deze zaagopdracht?",
        intro: "Onder {{material}}. Kies welke platen in de zaaglijst en visualisaties komen.",
        groupLabel: "Materiaalscope voor werkplan",
        newSheets: "Nieuwe standaardplaten",
        newSheetsDetail: "{{count}} plaat · {{size}}",
        newSheetsDetailPlural: "{{count}} platen · {{size}}",
        newSheetsNone: "Geen nieuwe platen nodig · {{size}}",
        restStock: "Restmateriaal",
        restDetail: "{{count}} stuk uit je voorraad",
        restDetailPlural: "{{count}} stukken uit je voorraad",
        restNone: "Geen restmateriaal in dit plan",
        onlyNewHint:
          "Handig voor de bouwmarkt: alleen nieuwe standaardplaten gaan mee. Onderdelen op restmateriaal vallen buiten deze zaagopdracht.",
        onlyRestHint:
          "Alleen restmateriaal gaat mee. Onderdelen op nieuwe standaardplaten vallen buiten deze zaagopdracht.",
        noneSelected: "Kies minimaal één optie om een zaaglijst te tonen.",
      },
      cutList: {
        title: "Zaaglijst · {{material}}",
        prepareHint:
          "Optioneel: verfijn zaagmaten en instructies per onderdeel. Voor de winkel gebruik je de tab Zaagopdracht.",
        oversizeHint: "Zaagmaten zijn bestelmaten; eindmaten staan in de kolom Eindmaat.",
        shopHint: "Graag zagen op onderstaande maten. Dit is de opdracht voor de zaagwinkel.",
        quantity: "Aantal",
        orderLength: "Zaagmaat lengte",
        orderWidth: "Zaagmaat breedte",
        finalSize: "Eindmaat",
        description: "Omschrijving",
        sheet: "Plaat",
        edges: "Randen",
        instruction: "Instructie / opmerking",
        remark: "Opmerking",
        resetInstruction: "Reset automatische instructie",
        resetOrderSize: "Reset zaagmaat",
        orderLengthFor: "Zaagmaat lengte voor {{name}}",
        orderWidthFor: "Zaagmaat breedte voor {{name}}",
        instructionFor: "Instructie voor {{name}}",
      },
      stripDelivery: {
        title: "Stroken te leveren (niet afkorten)",
        note: "Deze stroken graag als volledige strook leveren. Ik kort deze zelf op eindmaat.",
        sheet: "Plaat",
        thickness: "Dikte",
        part: "Onderdeel",
        stripSize: "Te leveren strook",
        finalSize: "Zelf afkorten naar",
        selfCut: "Verwacht zelf af te korten deel",
      },
      sawSettings: {
        title: "Zaaginstellingen",
        intro:
          "Deze instellingen bepalen hoe gezaagd wordt en hoe instructies in het werkplan worden geformuleerd. Ze bepalen niet welke platen je meeneemt.",
        strategy: {
          title: "Zaagstrategie",
          label: "Strategie",
          notPossible: " (niet mogelijk)",
          emphasizeExactSizes: "Zaagmaten expliciet benadrukken",
          showCutSequence: "Zaagsneden tonen (genummerd, per zaagstrategie)",
          statusLabel: "Status zaagstrategie",
          overridesSingular: "{{overrideCount}} van {{totalCount}} plaat wijkt af van de algemene strategie. Zie per plaat onder Visuele zaagindeling.",
          overridesPlural: "{{overrideCount}} van {{totalCount}} platen wijken af van de algemene strategie. Zie per plaat onder Visuele zaagindeling.",
          stripsUnavailable:
            "Stroken leveren past niet bij dit project: geen plaat heeft een eenvoudige strook-indeling.",
          stripsFallback:
            "Stroken is hier niet mogelijk; het werkplan valt terug op efficiënt zagen.",
          stripsPartial:
            "Stroken is mogelijk op {{eligibleCount}} van {{totalCount}} platen. Op de overige platen wordt automatisch efficiënt zagen getoond.",
          stripsActive:
            "De zaagwinkel zaagt alleen volledige stroken; jij kort thuis op eindmaat af.",
          stripDetailsSummary: "Meer over stroken leveren",
        },
        offcuts: {
          title: "Zaagresten",
          hint:
            "Overschot dat na het zagen op de plaat overblijft. Dat is niet het restmateriaal dat je al in huis had.",
          inactiveHint:
            "Zaagresten in het werkplan zijn alleen van toepassing bij grote zaagrest bewaren of stroken leveren.",
          minLength: "Minimale lengte bruikbare zaagresten",
          minWidth: "Minimale breedte bruikbare zaagresten",
          showInPlan: "Zaagresten in werkplan tonen",
        },
        orderSize: {
          title: "Bestelmaat (ruim leveren)",
          hint:
            "De zaagwinkel zaagt op de zaagmaat in de lijst. Eindmaten in je plan blijven leidend voor de indeling op de plaat.",
          inactiveHint:
            "Niet van toepassing bij stroken leveren. Pas per onderdeel handmatig de zaagmaat aan als je ruim wilt bestellen.",
          enable: "Ruim leveren; zelf thuis afwerken naar eindmaat",
          extraLength: "Extra op lengte (mm)",
          extraWidth: "Extra op breedte (mm)",
        },
        generalNote: {
          title: "Algemene instructie",
          hint: "Vrije tekst voor de zaagwinkel, bovenaan het werkplan.",
          label: "Algemene instructie",
          placeholder:
            "Bijvoorbeeld: graag zagen volgens onderstaande zaaglijst; zaagmaten zijn leidend.",
        },
      },
      simulator: {
        enableCutSequence:
          "Zet Zaagsneden tonen aan bij zaagstrategie om de zaagvolgorde te controleren.",
        noCuts:
          "Geen zaaglijnen om stap voor stap te tonen voor deze plaat en strategie.",
        teaserTitle: "Zaagvolgorde controleren",
        teaserCopy:
          "Controleer thuis de zaagvolgorde vóór je print of naar de zaagwinkel gaat.",
        openButton: "Volgorde bekijken",
        panelTitle: "Zaagvolgorde controleren",
        close: "Sluiten",
        panelHint:
          "Loop de genummerde snedes door om de volgorde te controleren vóór je print. Eerdere sneden blijven zichtbaar op het eindresultaat.",
        keyboardHint: "← → om te navigeren.",
        previous: "Vorige",
        next: "Volgende",
        stepSlider: "Zaagstap",
        stepStart: "Start",
        stepCut: "Snede {{current}}",
        stepProgress: "{{label}} / {{max}}",
        noCutsTitle: "Nog geen sneden uitgevoerd",
        noCutsDetail: "Stap door de genummerde snedes om de volgorde te controleren.",
        endLayoutTitle: "Eindlayout na alle sneden",
        endLayoutDetail:
          "Controleer of de volgorde klopt vóór je print of naar de zaagwinkel gaat.",
        cutStepTitle: "Snede {{number}}: {{caption}}",
        mobileStepsHeading: "Zaagstappenoverzicht",
        mobileStepsNote:
          "Op telefoon en tablet zie je hier alle sneden als tekst. Op desktop kun je de volgorde interactief doorlopen.",
      },
    },
  },
};
